// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"e391dea2","488":"60c13d15","796":"8c17e596"}[chunkId] + ".chunk.js";
};